const toolPaths = [
    'color-details',
    'color-harmonies',
    'color-mixer',
    'color-style-guide',
    'color-theme',
    'color-tones',
    'color-wheel',
    'dominant-image-colors',
    'lighten-and-darken',
    'tints-and-shades',
    'app/color-library',
];

export const getAnalyticsTool = (pathname = '') => {
    const path = pathname.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    return toolPaths.includes(path) ? path.replace('app/', '') : undefined;
};

export const getAnalyticsUser = (user) => ({
    user_tier: ['free', 'premium'].includes(user?.subscription) ? user.subscription : 'unknown',
    ...(typeof user?.activeSubscription === 'boolean'
        ? { active_subscription: user.activeSubscription }
        : {}),
});

// Analytics must never interrupt navigation, mutations, or downloads.
export const trackEvent = (event, context = {}) => {
    try {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
        window.gtag('event', event, { ...context, library_cohort: 'free_library_v2' });
        return true;
    } catch {
        return false;
    }
};
